// import Vue from 'vue';
import Router from 'vue-router';
import Index from './views/index.vue';
import Orders from './views/orders.vue';
import Login from './views/login.vue';
import pub from './../common/public';
import Collection from './views/collection';
import History from './views/history';
import Subscribe from './views/subscribe';
import EditSubscribe from './views/editSubscribe';
import EstatePrice from './views/estatePrice';
import Register from './views/register.vue';
import Messages from './views/messages.vue';
// import MessageReply from './views/messageReply.vue';
// import MessageChange from './views/messageChange.vue';
import postTest from './views/postTest.vue';
import post from './views/post/index.vue'
// import photo from './components/post/up_pic.vue';
import photos from './views/post/photo.vue'
import editProperties from './views/editProperty.vue';
import addressCheck from './views/post/verifile.vue';
import searchBuilding from './views/post/searchAddress.vue';
import words from './views/post/commonWord.vue'
import videos from "./views/post/videos.vue"
import tags from './views/post/tags.vue'
// import platimg from './views/post/platimg.vue'
import platimg from './views/post/newPlatimg.vue'
// import platimgBig from './views/post/platimgBig.vue'



import EditUser from './views/editUser.vue';
import EditPassword from './views/edit-user/editPassword.vue';
import setPassword from './views/edit-user/setPassword.vue';
import setEmail from './views/edit-user/setEmail.vue';
import editTel from './views/edit-user/editTelephone.vue';


import editProDetail from './views/editProDetail.vue';
import Verify from './views/verify.vue';
import Forget from './views/forget.vue';
import storedValueMoney from './views/storedValueMoney.vue';
import help from './views/help.vue';
import scan from './views/up_scan.vue';
// import skip from './views/skip.vue';
import pay from './views/pay.vue';
import bankInfo from './views/bankinfo.vue';
// import term from './views/term.vue'
//new login
import newLogin from './views/newlogin/login.vue';
import forget from "./views/newlogin/forget-password.vue";
import reset from "./views/newlogin/reset-password.vue";
import success from "./views/newlogin/success.vue";
import school from "./views/newlogin/school.vue";
//
// const Login = r => require.ensure([], () => r(require('./views/login')), 'group-home');
// const Register = r => require.ensure([], () => r(require('./views/register')), 'group-home');
// const Forget = r => require.ensure([], () => r(require('./views/forget')), 'group-home');
// const Verify = r => require.ensure([], () => r(require('./views/verify')), 'group-home');
// const Index = r => require.ensure([], () => r(require('./views/index')), 'group-home');

Vue.use(Router);

const router = new Router({
 mode: 'history',
 base: pub.getLang() === 'zh-hk' ? '/my/' : `/my/${pub.getLang()}/`,
 scrollBehavior(to, from, s) {
  if (s) return s;
  return {
   x: 0,
   y: 0
  };
 },
 routes: [
  //new login
  {
   path: '/login',
   name: 'login',
   component: newLogin
  },
  {
   path: '/forget',
   name: 'forget_password',
   component: forget
  },
  {
   path: '/reset',
   name: 'reset',
   component: reset
  },


  {
   path: '/success',
   name: 'success',
   component: success
  },
  {
    path: '/school',
    name: 'school',
    component: school
   },
  //end
  {
   path: '/',
   name: 'index',
   component: Index,
   // meta: {
   //   keepAlive: true
   // }
  },
  {
   path: '/edit-user',
   name: 'edit-user',
   component: EditUser
  },
  {
   path: '/edit-password',
   name: 'edit-password',
   component: EditPassword
  },
  {
   path: '/set-password',
   name: 'set-password',
   component: setPassword
  },
  {
   path: '/set-email',
   name: 'set-email',
   component: setEmail
  },
  {
   path: '/edit-telephone',
   name: 'edit-telephone',
   component: editTel
  },
  {
   path: '/photos',
   component: photos,
   name: 'photos'
  },
  {
   path: '/post',
   name: 'post',
   component: post,
   meta: {
    keepAlive: true
   }
  },
  /*兼容ios||安卓未修改为最新的url*/
  {
   path: '/post/step1',
   name: 'post',
   component: post,
   meta: {
    keepAlive: true
   }
  },
  {
   path: '/prop-search',
   name: 'searchBuilding',
   component: searchBuilding
  },
  {
    path:'/commonword',
    name:'commonword',
    component:words
  },
  {
    path:'/videos',
    name:"videos",
    component:videos
  },
  {
    path:'/tags',
    name:"tags",
    component:tags
  },
  {
    path:'/platimg',
    name:"platimg",
    component:platimg
  },
  {
   path: '/addressCheck',
   name: 'addressCheck',
   component: addressCheck
  },
  // {
  //  path: '/platimgBig',
  //  name: 'platimgBig',
  //  component: platimgBig
  // },

  // {
  //   path: '/post-test',
  //   name: 'postTest',
  //   component: postTest,
  //   children: [
  //     {
  //       path: 'edit',
  //       name: 'edit',
  //       component: postTest
  //     },
  //     {
  //       path: 'copy',
  //       name: 'copy',
  //       component: postTest
  //     },
  //     {
  //       path: 'pay',
  //       name: 'payMethods',
  //       component: postTest
  //     }
  //   ]
  // },
  {
   path: '/bankinfo',
   name: 'bankInfo',
   component: bankInfo
  },
  {
   path: '/my-properties',
   name: 'editProperties',
  //  redirect:'/lipu',
   component: editProperties
  },
  // {
  //   path: '/lipu',
  //   name: 'editProperties',
  //   component: editProperties
  //  },
  {
   path: '/editProDetail/:id',
   name: 'editProDetail',
   component: editProDetail
  },
  {
   path: '/orders',
   name: 'orders',
   component: Orders
  },
  // {
  //   path: '/login',
  //   name: 'login',
  //   component: Login
  // },
  {
   path: '/register',
   name: 'register',
   component: Register
  },
  {
   path: '/messages',
   name: 'messages',
   component: Messages
  },
  // {
  //   path: '/message-reply',
  //   name: 'messageReply',
  //   component: MessageReply
  // },
  // {
  //   path: '/message-change',
  //   name: 'messageChange',
  //   component: MessageChange
  // },

  {
   path: '/post',
   name: 'post',
   component: post,
   children: [{
     path: 'edit',
     name: 'edit',
     component: post
    },
    {
     path: 'copy',
     name: 'copy',
     component: post
    },
    {
     path: 'pay',
     name: 'payMethods',
     component: post
    }
   ]
  },
  {
   path: '/bankinfo',
   name: 'bankInfo',
   component: bankInfo
  },
  // {
  //   path: '/prop-search',
  //   name: 'searchBuilding',
  //   component: searchBuilding
  // },
  {
   path: '/addressCheck',
   name: 'addressCheck',
   component: addressCheck
  },
  // {
  //   path: '/post/photos',
  //   name: 'photo',
  //   component: photo
  // },

  {
   path: '/my-properties',
   name: 'editProperties',
   component: editProperties
  },
  {
   path: '/editProDetail/:id',
   name: 'editProDetail',
   component: editProDetail
  },
  {
   path: '/orders',
   name: 'orders',
   component: Orders
  },
  // {
  //   path: '/login',
  //   name: 'login',
  //   component: Login
  // },
  {
   path: '/register',
   name: 'register',
   component: Register
  },
  {
   path: '/messages',
   name: 'messages',
   component: Messages
  },
  // {
  //   path: '/message-reply',
  //   name: 'messageReply',
  //   component: MessageReply
  // },
  // {
  //   path: '/message-change',
  //   name: 'messageChange',
  //   component: MessageChange
  // },

  // {
  //   path: '*',
  //   name: '404',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ './views/404.vue')
  // },
  {
   path: '/collection',
   name: 'collection',
   component: Collection
  },
  {
   path: '/history',
   name: 'history',
   component: History
  },
  {
    path: '/subscribe',
    name: 'subscribe',
    component: Subscribe
   },
   {
    path: '/editSubscribe',
    name: 'editSubscribe',
    component: EditSubscribe
   },
  {
   path: '/estatePrice',
   name: 'estatePrice',
   component: EstatePrice
  },
  {
   path: '/account/forget',
   name: 'forget',
   component: Forget
  },
  {
   path: '/account/verify',
   name: 'verify',
   component: Verify
  },
  {
   path: '/account/tips',
   name: 'tips',
   component: Verify
  },
  {
   path: '/storedValueMoney',
   name: 'storedValueMoney',
   component: storedValueMoney
  },
  {
   path: '/help',
   name: 'help',
   component: help
  },
  // {
  //   path: '/skip',
  //   name: 'skip',
  //   component: skip
  // },
  {
   path: '/pay',
   name: 'pay',
   component: pay
  },
  {
   path: '/scan',
   name: 'scan',
   component: scan
  }

  // {
  //   path: '/term',
  //   name: 'term',
  //   component: term
  // }
 ]
});
router.beforeEach((to, from, next) => {
  /**
   * !to.path.includes('/history') &&
   * 由于浏览历史页也需要使用用户token 来判断是否有收藏楼盘 所以浏览历史必须登录查看
   */

 if (
  !pub.getCookie('cEVaUDFrZ1kd0RA') &&
  !to.path.includes('/login') &&
  !to.path.includes('/account') &&
  !to.path.includes('/reg') &&
  !to.path.includes('/skip') &&
  !to.path.includes('/help') &&
  !to.path.includes('/bankinfo') &&
  !to.path.includes('/estatePrice') &&
  !to.path.includes('/contact-us') &&
  !to.path.includes('/term') &&
  !to.path.includes('/scan') &&
  !to.path.includes('/forget') &&
  !to.path.includes('/reset') &&
  !to.path.includes('/success') &&
  !to.path.includes('/school') &&
  !to.fullPath.includes('/set-email?cid=')
 ) {
  if (navigator.userAgent.indexOf('house730') > -1) {
   let isAndroid = navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1; //android终端
   const isFlutter = navigator.userAgent.indexOf('flutter') > -1;
   if (isFlutter) {
    window.house730.postMessage(JSON.stringify({
     type: 'jumpLogin',
     data: {}
    }));
   } else if (isAndroid) {
    window.house730.jumpLogin();
   } else {
    window.webkit.messageHandlers.jumpLogin.postMessage(JSON.stringify({}));
   }
  } else {
    const _conf = require('../common/js/_conf');
    const helpConfig = _conf.env_type == 3 ?'https://www.house730.com': _conf.env_type == 4?'https://sim.house730.com':'https://uat.house730.com.cn'
    const langBase =  pub.getLang() === 'zh-hk' ? '/my' : `/my/${pub.getLang()}`
    window.location.href = `${helpConfig}${langBase}/login?referrer=${location.href}`
    // router.push(`/login?referrer=${location.href}`);
  }
 } else next();
});
router.afterEach(to => {
  if (!window.sessionStorage.firstUrl) {
    window.sessionStorage.firstUrl = location.href;
  }
 typeof gtag != 'undefined' ?
  gtag('config', 'UA-139040958-2', {
   page_path: to.fullPath
  }) :
  '';
 // window.adsbygoogle|| (window.adsbygoogle = []);
 // window.adsbygoogle.push({
 //   google_ad_client: "ca-pub-7195027962940131",
 //   enable_page_level_ads: true
 // });
});

export default router;